import { render, staticRenderFns } from "./TopCountsPanel.vue?vue&type=template&id=65e76714&scoped=true&"
import script from "./TopCountsPanel.vue?vue&type=script&lang=js&"
export * from "./TopCountsPanel.vue?vue&type=script&lang=js&"
import style0 from "./TopCountsPanel.vue?vue&type=style&index=0&id=65e76714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e76714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e76714')) {
      api.createRecord('65e76714', component.options)
    } else {
      api.reload('65e76714', component.options)
    }
    module.hot.accept("./TopCountsPanel.vue?vue&type=template&id=65e76714&scoped=true&", function () {
      api.rerender('65e76714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/home/TopCountsPanel.vue"
export default component.exports